// extracted by mini-css-extract-plugin
export default {"Grow":"PayCardSlider_Grow__UxbVF","Shrink":"PayCardSlider_Shrink__aY4tL","Option":"PayCardSlider_Option__UIJFr","Slider":"PayCardSlider_Slider__YQ5ZE"};